import React from 'react';

const withOnKeyDown = (Component) =>
    class WithOnKeyDown extends React.Component {
        handleOnKeyDown = (e) => {
            const { onClick } = this.props;
            //  need to gracefully handle keycode deprecation
            if (e.key && e.key === 'Enter') {
                if (onClick) onClick(this.props);
            } else if (e.keyCode && e.keyCode === 13) {
                if (onClick) onClick(this.props);
            }
        };

        render() {
            return <Component {...this.props} onKeyDown={this.handleOnKeyDown} />;
        }
    };

export default withOnKeyDown;
